import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { CANGURO_LOGO_URL } from '../data';

const Hero = () => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        overflow: 'hidden',
        bgcolor: theme.palette.primary.main,
      }}
    >
      <Box position="relative" zIndex={1} width="100%" py={{ xs: 6, md: 8 }}>
        <Container>
          <Box textAlign="center" color="secondary.main">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_tnonetwork_black.png)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 56, md: 80 },
                maxWidth: 240,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
              color="secondary"
            >
              Propuesta Comercial
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center" color="secondary">
              Canguro × TNO Network
            </Typography>
            <Typography
              variant="h6"
              component="p"
              align="center"
              color="secondary"
              sx={{ fontWeight: 600, fontStyle: 'italic' }}
            >
              Tu Vida Digital sin Interrupciones
            </Typography>

            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: 720,
                mx: 'auto',
                mt: 4,
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
                aspectRatio: '16 / 9',
                bgcolor: '#1a1a1a',
                border: `3px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Box
                component="img"
                src={CANGURO_LOGO_URL}
                alt="Canguro"
                sx={{
                  maxWidth: { xs: '62%', sm: '48%' },
                  maxHeight: '45%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  pointerEvents: 'none',
                  animation: 'canguroLogoPulse 3s ease-in-out infinite',
                  '@keyframes canguroLogoPulse': {
                    '0%, 100%': { transform: 'scale(1)' },
                    '50%': { transform: 'scale(1.04)' },
                  },
                }}
              />
            </Box>

            <Typography
              variant="body1"
              align="center"
              color="secondary"
              sx={{ mt: 3, maxWidth: 640, mx: 'auto', opacity: 0.9 }}
            >
              Atracción orgánica con contenido de alto valor: micros, inserts en vivo, programas selectivos,
              TNO Digest y redes — conectando las soluciones de Canguro con las audiencias clave de TNO Network.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
